import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
// import { useHistory } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Formik, Field } from 'formik';
import Card from '@material-ui/core/Card';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { blue } from '@material-ui/core/colors';
import Input from '@material-ui/core/Input';
import { Grid } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
    createGenInfoRequestSave,
    createAddAdditionalQue,
    panelIndexUpdate,
} from '../../../modules/checkListGenerator/store/actions/index';
import CrcDialog from '../../../modules/checkListGenerator/crcChecklist/crcChecklistAddRelevancePopUp';
import { CommonConfig } from '../../../config/common-config';
import buttonDisable from '../../disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import fieldDisable from '../../../components/disableField/fieldDisable';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../../components/modal/previewModal';
import PreviewImage from '../../../assets/previewImage.png';
import downloadImage from '../../../assets/downloadImage.png';
import LoaderPopUp from '../../../components/loaderpopup/loader';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
}));
const BlueSwitch = withStyles({
    switchBase: {
        color: blue[300],
        '&$checked': {
            color: blue[500],
        },
        '&$checked + $track': {
            backgroundColor: blue[500],
        },
    },
    checked: {},
    track: {},
})(Switch);
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function CRCClientAddAdditional(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [isDisable, setIsDisable] = useState(true);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const createADDAdditionalQue = useSelector((state) => state.geninforeducer.createaddadditionalQue);

    const [apiResponse, setApiResponse] = React.useState('');
    const checklist = apiResponse && apiResponse[0].fields;
    let tempArr = apiResponse && apiResponse[0].fields;
    const [apithirdscreenvalues, setApithirdscreenvalues] = React.useState('');
    const [apiResponseBank, setApiResponseBank] = React.useState('');
    const [apiincomeTaxValues, setApiincomeTaxValues] = React.useState('');
    const [apigeneralinfo, setApigeneralinfo] = React.useState('');
    const [apitravelOutside, setApitravelOutside] = React.useState('');
    const [apidirectorCompany, setApidirectorCompany] = React.useState('');
    const [apiassetHome, setApiassetHome] = React.useState('');
    const [apiassetNature, setApiassetNature] = React.useState('');
    const [apiclient1, setApiclient1] = React.useState('');
    const [apiclient2, setApiclient2] = React.useState('');
    const [apiclient3, setApiclient3] = React.useState('');
    const [apiclient4, setApiclient4] = React.useState('');
    const [apiclient5, setApiclient5] = React.useState('');
    const [apiclient6, setApiclient6] = React.useState('');
    const [apiclient7, setApiclient7] = React.useState('');
    const [apiclient8, setApiclient8] = React.useState('');
    const [apiclient9, setApiclient9] = React.useState('');
    const [apiclient10, setApiclient10] = React.useState('');
    const [apilabelAdata, setApilabelAdata] = React.useState('');
    const [apilabelBdata, setApilabelBdata] = React.useState('');
    const [apilabelCdata, setApilabelCdata] = React.useState('');
    const [apilabelDdata, setApilabelDdata] = React.useState('');
    const [apilabelEdata, setApilabelEdata] = React.useState('');

    const [apiyesorNoType, setApiyesorNoType] = React.useState('');

    const [relevenceDispay, setRelevenceDispay] = useState('');
    const [category, setCategory] = React.useState('');
    const [remarks, setRemarks] = React.useState('');
    const [relevanceCat, setRelevanceCat] = React.useState('');
    const [itecOpen, setItecOpen] = React.useState(false);

    const [updateStat, setUpdateStat] = useState(false);

    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const tennantName = tennantnameValue && tennantnameValue.toUpperCase();
    const [URLValue, setURLValue] = useState();
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const statusId = props.statusId;

    const tempcreatetotalincomelabele = useSelector((state) => state.geninforeducer.createtotalincomelabele);
    const tempcreatetotalincomelabelevalue = tempcreatetotalincomelabele && tempcreatetotalincomelabele.params;
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [updatedFieldIndex, setUpdatedFieldIndex] = React.useState('');

    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[0].branchName;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);

    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);

    const [files, setFiles] = useState([]);
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [fileIndex, setFileIndex] = useState('');
    const [checklistQue, setChecklistQue] = useState('');
    const [checklistArr, setChecklistArr] = useState([]);
    // console.log("checklistArr", checklistArr);
    const [showLoader, setShowLoader] = useState(false);
    const userTypeValue = userDetails.result && userDetails.result.data.features[0].branchName;

    const handleClick = () => {
        setHandleOpen(true);
        setClearData('');
    };

    const handleClose = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setFilename(null);
    };

    const handleRelevence = (name, categoryValue, remarksValue, updateFieldIndex) => {
        // console.log('categoryValue', categoryValue)
        setCategory(categoryValue);
        setRemarks(remarksValue);
        setRelevanceCat(name);
        // setItecOpen(true);
        setUpdatedFieldIndex(updateFieldIndex);
        setTimeout(() => {
            setItecOpen(true);
        }, 2000);
    };

    const handleItecClose = () => {
        setTimeout(() => {
            setItecOpen(false);
        }, 1000);
    };

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e xlsx/xls/csv');
                setIsDisable(true);
            }
        }
    };
    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantnameValue}/${serviceIdValue}/myimage`, data, axiosConfig)
            .then((response) => {
                if (response.data) {
                    setURLValue(response.data);
                    setUploadSuccessfully('Uploaded a file successfully');
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };
    const [selectedFileData, setSelectedFileData] = useState(null);

    useEffect(() => {
        setApiResponse(props.apiResponse);
        setApiResponseBank(props.bankDetails);
        setApithirdscreenvalues(props.thirdscreenvalues);
        setApiincomeTaxValues(props.incomeTaxValues);
        setApigeneralinfo(props.generalinfo);
        setApitravelOutside(props.travelOutside);
        setApidirectorCompany(props.directorCompany);
        setApiassetHome(props.assetHome);
        setApiassetNature(props.assetNature);
        setApiclient1(props.client1);
        setApiclient2(props.client2);
        setApiclient3(props.client3);
        setApiclient4(props.client4);
        setApiclient5(props.client5);
        setApiclient6(props.client6);
        setApiclient7(props.client7);
        setApiclient8(props.client8);
        setApiclient9(props.client9);
        setApiclient10(props.client10);
        setApilabelAdata(props.labelAdata);
        setApilabelBdata(props.labelBdata);
        setApilabelCdata(props.labelCdata);
        setApilabelDdata(props.labelDdata);
        setApilabelEdata(props.labelEdata);

        setApiyesorNoType(props.yesorNoType);

        //console.log('userType.historyStageId, stageId', userType.historyStageId, stageId)
        if (userType.historyStageId <= stageId) {
            // console.log('history view')
            if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
                // console.log('history view for ITECAM')

                setTimeout(() => {
                    axios
                        .get(
                            `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                                tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                            }/${serviceIdValue}`,
                            {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            }
                        )
                        .then((response) => {
                            if (response && response.data) {
                                //console.log('responseView', response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                                setChecklistArr(response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                            }
                            // dispatch(getGenInfoRequest(response.data.checklistJson.checklistL1));
                        })
                        .catch((error) => {});
                }, 5000);
            } else {
                // console.log('history view for inside')

                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                            tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                        }/${serviceIdValue}/${userType.historyStageId}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        let tempObj = response.data;
                        tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                        //console.log('JSON.parse(response.data)', tempObj)
                        if (response && response.data) {
                            //console.log('responseView', tempObj.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                            setChecklistArr(tempObj.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                        }
                    })
                    .catch((error) => {});
            }
        } else {
            // console.log('active view')
            setTimeout(() => {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                            tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                        }/${serviceIdValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        if (response && response.data) {
                            //console.log('responseView', response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                            setChecklistArr(response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields);
                        }
                        // dispatch(getGenInfoRequest(response.data.checklistJson.checklistL1));
                    })
                    .catch((error) => {});
            }, 5000);
        }

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${
                    tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                // let temp = [];
                // response.data.filter((ele, i) => {
                //     temp.push({ filePath: ele.attachmentUrls && ele.attachmentUrls.length ? ele.attachmentUrls : '' });
                // })
                // setFiles(temp);
                //console.log('response.data', response.data)
                setChecklistQue(response.data);
            })
            .catch((error) => {});

        //console.log('checklistchecklist', checklist)
        let temp = [];
        let flag = true;
        for (let i = 0; i < checklist.length; i++) {
            if (checklist[i].relevanceResponseAM === 'uploadFile') {
                flag = false;
                let tempObj = {
                    filePath: checklist[i].response,
                };
                temp.push(tempObj);
            }
        }
        if (!flag) {
            //console.log('temptemp', temp)
            setFiles(temp);
        }
    }, [props]);

    const handleModalClose = () => {
        setVisible(false);
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        // setShowLoaderSave(true);
        setTimeout(() => {
            // setShowLoaderSave(false);
            setVisible(true);
        }, 1000);
    };

    const initialValues = {};
    let data = [];
    let Add = [];

    const updateCRCRelevance = (category, remarks) => {
        // setShowLoader(true);

        setTimeout(() => {
            setItecOpen(false);
        }, 3000);
        let additionalQueData = [];
        for (let i = 0; i < checklistArr.length; i++) {
            let additionalQueDataJson = {
                response: checklistArr[i].response,
                questionId: checklistArr[i].relevanceRemarksAM,
                questionText: checklistArr[i].relevanceResponseAM,
                relevanceRemarksCRC: checklistArr[i].relevanceRemarksCRC,
                relevanceResponseCRC: checklistArr[i].relevanceResponseCRC,
            };
            additionalQueData.push(additionalQueDataJson);
        }

        //console.log('additionalQueData', additionalQueData, tempArr)

        additionalQueData[updatedFieldIndex].relevanceRemarksCRC = remarks;
        additionalQueData[updatedFieldIndex].relevanceResponseCRC = category;

        // checklistArr[updatedFieldIndex].relevanceRemarksCRC = remarks;
        // checklistArr[updatedFieldIndex].relevanceResponseCRC = category;

        // //console.log('additionalQueData11', additionalQueData[0], additionalQueData[1], additionalQueData);
        // //console.log('tempArr', tempArr)
        // //console.log('response Additional', checklistArr[0], checklistArr[1], checklistArr)

        let data1 = {
            additionalQue: additionalQueData,
            bankDetails: apiResponseBank,
            ...apigeneralinfo,
            ...apiincomeTaxValues,
            ...apithirdscreenvalues,
            travelOutside: apitravelOutside,
            directorCompany: apidirectorCompany,
            assetHome: apiassetHome,
            assetNature: apiassetNature,
            client1: apiclient1,
            client2: apiclient2,
            client3: apiclient3,
            client4: apiclient4,
            client5: apiclient5,
            client6: apiclient6,
            client7: apiclient7,
            client8: apiclient8,
            client9: apiclient9,
            client10: apiclient10,
            labelAdata: apilabelAdata,
            labelBdata: apilabelBdata,
            labelCdata: apilabelCdata,
            labelDdata: apilabelDdata,
            labelEdata: apilabelEdata,

            incomeTaxType: apiyesorNoType && apiyesorNoType.incomeTaxType,
            traveloutsideType: apiyesorNoType && apiyesorNoType.traveloutsideType,
            directorType: apiyesorNoType && apiyesorNoType.directorType,
            assetradio: apiyesorNoType && apiyesorNoType.assetradio,
            totalincomeradio: apiyesorNoType && apiyesorNoType.totalincomeradio,
        };

        // console.log('datadata', data1)
        setRelevenceDispay(data1);
        dispatch(createAddAdditionalQue({ params: data1, serviceIdValue: serviceIdValue }));
        dispatch(panelIndexUpdate({ panelID: 'panel9' }));

        dispatch(createGenInfoRequestSave({ params: data1, bearerToken, serviceIdValue: serviceIdValue, usertype, imcNameSelected }));
        // setTimeout(() => {
        props.onChange(data1);
        props.rerenderApi(!props.rerender);
        // }, 200);
        // setTimeout(() => {
        //     setShowLoader(false);
        // }, 10000);
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}

            <Formik initialValues={initialValues} enableReinitialize>
                {(formik) => {
                    // //console.log('checklistchecklist',checklist, createADDAdditionalQue, serviceIdValue)
                    return (
                        <>
                            {/* <Snackbar
                            className="deleteError"
                            open={updateStat}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            autoHideDuration={3000}
                            onClose={() => {
                                setUpdateStat(false);
                            }}
                        >
                            <Alert
                                onClose={() => {
                                    setUpdateStat(false);
                                }}
                            >
                                Successfully submitted L1 Checklist.
                            </Alert>
                        </Snackbar> */}

                            <Card className="client-card">
                                {/* <CardContent className="client-heading">
                                <Typography variant="h5">Answer Additional Question</Typography>
                            </CardContent> */}
                                <CardContent>
                                    <form onSubmit={formik.handleSubmit} className="container-form">
                                        <div>
                                            {checklistArr &&
                                                checklistArr.map((user, index) => {
                                                    return (
                                                        <span>
                                                            {user.relevanceResponseAM !== 'uploadFile' ? (
                                                                <Grid container spacing={3} className="main-container" key={index}>
                                                                    <Grid item xs={12} sm={12}>
                                                                        <FormControl fullWidth>
                                                                            <Typography variant="subtitle1" gutterBottom>
                                                                                {user.relevanceResponseAM}
                                                                            </Typography>
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Field name={user}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                field.value = user.response;
                                                                                return (
                                                                                    <>
                                                                                        <FormControl fullWidth>
                                                                                            <Input
                                                                                                className={classes.bottomLine}
                                                                                                disabled={fieldDisable(
                                                                                                    stageId,
                                                                                                    relevenceDispay.additionalQue &&
                                                                                                        relevenceDispay.additionalQue[
                                                                                                            index
                                                                                                        ] &&
                                                                                                        relevenceDispay.additionalQue[index]
                                                                                                            .relevanceRemarksCRC
                                                                                                )}
                                                                                                {...field}
                                                                                            />
                                                                                            {meta.touched && meta.error ? (
                                                                                                <span className="itec-validationError">
                                                                                                    {meta.error}
                                                                                                </span>
                                                                                            ) : null}
                                                                                            {/* {createADDAdditionalQue &&
                                                                                            createADDAdditionalQue.serviceIdValue === serviceIdValue ? ( */}

                                                                                            {/* {relevenceDispay.additionalQue &&
                                                                                                relevenceDispay.additionalQue[index] ? ( */}

                                                                                            {checklistArr && checklistArr[index] ? (
                                                                                                checklistArr &&
                                                                                                checklistArr[index].relevanceResponseCRC ===
                                                                                                    'Relevant' ? (
                                                                                                    <div
                                                                                                        className={
                                                                                                            classes.relevanceIndicator
                                                                                                        }
                                                                                                    >
                                                                                                        {checklistArr &&
                                                                                                            checklistArr[index]
                                                                                                                .relevanceRemarksCRC}
                                                                                                    </div>
                                                                                                ) : checklistArr &&
                                                                                                  checklistArr[index]
                                                                                                      .relevanceResponseCRC ===
                                                                                                      'Irrelavant' ? (
                                                                                                    <div
                                                                                                        className={
                                                                                                            classes.irrelevanceIndicator
                                                                                                        }
                                                                                                    >
                                                                                                        {checklistArr &&
                                                                                                            checklistArr[index]
                                                                                                                .relevanceRemarksCRC}
                                                                                                    </div>
                                                                                                ) : checklistArr &&
                                                                                                  checklistArr[index]
                                                                                                      .relevanceResponseCRC ===
                                                                                                      'Paritially Relevant' ? (
                                                                                                    <div
                                                                                                        className={
                                                                                                            classes.partrelevanceIndicator
                                                                                                        }
                                                                                                    >
                                                                                                        {checklistArr &&
                                                                                                            checklistArr[index]
                                                                                                                .relevanceRemarksCRC}
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    ''
                                                                                                )
                                                                                            ) : (
                                                                                                <div>
                                                                                                    <Typography
                                                                                                        className={classes.bottomLine}
                                                                                                    >
                                                                                                        {relevenceDispay.additionalQue &&
                                                                                                        relevenceDispay.additionalQue[index]
                                                                                                            .relevanceResponseCRC ===
                                                                                                            'Relevant' ? (
                                                                                                            <div
                                                                                                                className={
                                                                                                                    classes.relevanceIndicator
                                                                                                                }
                                                                                                            >
                                                                                                                {relevenceDispay.additionalQue &&
                                                                                                                    relevenceDispay
                                                                                                                        .additionalQue[
                                                                                                                        index
                                                                                                                    ]
                                                                                                                        .relevanceRemarksCRC}{' '}
                                                                                                            </div>
                                                                                                        ) : (relevenceDispay.additionalQue &&
                                                                                                              relevenceDispay.additionalQue[
                                                                                                                  index
                                                                                                              ].relevanceResponseCRC) ===
                                                                                                          'Irrelavant' ? (
                                                                                                            <div
                                                                                                                className={
                                                                                                                    classes.irrelevanceIndicator
                                                                                                                }
                                                                                                            >
                                                                                                                {relevenceDispay.additionalQue &&
                                                                                                                    relevenceDispay
                                                                                                                        .additionalQue[
                                                                                                                        index
                                                                                                                    ].relevanceRemarksCRC}
                                                                                                            </div>
                                                                                                        ) : (relevenceDispay.additionalQue &&
                                                                                                              relevenceDispay.additionalQue[
                                                                                                                  index
                                                                                                              ].relevanceResponseCRC) ===
                                                                                                          'Paritially Relevant' ? (
                                                                                                            <div
                                                                                                                className={
                                                                                                                    classes.partrelevanceIndicator
                                                                                                                }
                                                                                                            >
                                                                                                                {relevenceDispay.additionalQue &&
                                                                                                                    relevenceDispay
                                                                                                                        .additionalQue[
                                                                                                                        index
                                                                                                                    ].relevanceRemarksCRC}
                                                                                                            </div>
                                                                                                        ) : (
                                                                                                            ''
                                                                                                        )}
                                                                                                    </Typography>
                                                                                                </div>
                                                                                            )}

                                                                                            {stageId === 10 && usertype === 'EM' ? (
                                                                                                ''
                                                                                            ) : (
                                                                                                <Button
                                                                                                    disabled={
                                                                                                        usertype === 'EM' ? 'disabled' : ''
                                                                                                    }
                                                                                                    variant="outlined"
                                                                                                    color="primary"
                                                                                                    size="small"
                                                                                                    className={classes.button}
                                                                                                    startIcon={<InsertCommentIcon />}
                                                                                                    onClick={() =>
                                                                                                        handleRelevence(
                                                                                                            'remarks',
                                                                                                            (relevenceDispay.additionalQue &&
                                                                                                                relevenceDispay
                                                                                                                    .additionalQue[index]
                                                                                                                    .remarksRelevance) ||
                                                                                                                (checklist &&
                                                                                                                    checklist.length &&
                                                                                                                    checklist[index]
                                                                                                                        .relevanceResponseCRC),
                                                                                                            (relevenceDispay.additionalQue &&
                                                                                                                relevenceDispay
                                                                                                                    .additionalQue[index]
                                                                                                                    .remarksRelevanceRemarks) ||
                                                                                                                (checklist &&
                                                                                                                    checklist.length &&
                                                                                                                    checklist[index]
                                                                                                                        .relevanceRemarksCRC),
                                                                                                            index
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={buttonDisable(
                                                                                                        stageId,
                                                                                                        userType.value
                                                                                                    )}
                                                                                                >
                                                                                                    Add Relevance
                                                                                                </Button>
                                                                                            )}
                                                                                        </FormControl>
                                                                                        {/* {user.isAttachmentRequired === true ? (
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth>

                                                                                        {files[index].filePath ?
                                                                                            <span style={{ paddingTop: '12px', display: 'flex' }}>
                                                                                                <span className={classes.fileView}>{files[index].filePath.substring(response.lastIndexOf('/') + 1)}</span>
                                                                                                <span onClick={() => handlePreviewModal(files[index].filePath)}>
                                                                                                    <Tooltip title="Preview">
                                                                                                        <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                                                                    </Tooltip>
                                                                                                </span>
                                                                                            </span> : null}
                                                                                    </FormControl>

                                                                                </Grid>
                                                                            ) : (
                                                                                ''
                                                                            )} */}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                    </Grid>
                                                                    {checklistQue && checklistQue.length && checklistQue[index] ? (
                                                                        <span>
                                                                            {checklistQue[index].isAttachmentRequired === true ? (
                                                                                // <Grid item xs={12} sm={6}>
                                                                                <FormControl fullWidth>
                                                                                    {files &&
                                                                                    files.length &&
                                                                                    files[index] &&
                                                                                    files[index].filePath ? (
                                                                                        <span>
                                                                                            {files[index].filePath ? (
                                                                                                <span
                                                                                                    style={{
                                                                                                        paddingTop: '12px',
                                                                                                        display: 'flex',
                                                                                                    }}
                                                                                                >
                                                                                                    {files[index].filePath ? (
                                                                                                        <span>
                                                                                                            {files[index].filePath
                                                                                                                .substring(
                                                                                                                    files[
                                                                                                                        index
                                                                                                                    ].filePath.lastIndexOf(
                                                                                                                        '/'
                                                                                                                    ) + 1
                                                                                                                )
                                                                                                                .substring(0, 15)}
                                                                                                            {files[
                                                                                                                index
                                                                                                            ].filePath.substring(
                                                                                                                files[
                                                                                                                    index
                                                                                                                ].filePath.lastIndexOf(
                                                                                                                    '/'
                                                                                                                ) + 1
                                                                                                            ).length > 15
                                                                                                                ? '...'
                                                                                                                : ''}
                                                                                                        </span>
                                                                                                    ) : null}
                                                                                                    <span
                                                                                                        style={{
                                                                                                            marginTop: '-8px',
                                                                                                            marginLeft: '12px',
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            handlePreviewModal(
                                                                                                                files[index].filePath
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Tooltip title="Preview">
                                                                                                            <img
                                                                                                                src={PreviewImage}
                                                                                                                alt="PreviewImage"
                                                                                                                className="fileView"
                                                                                                            />
                                                                                                        </Tooltip>
                                                                                                    </span>
                                                                                                    <span
                                                                                                        style={{ marginTop: '-11px' }}
                                                                                                        onClick={() =>
                                                                                                            downloadCoreFile(
                                                                                                                files[index].filePath
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Tooltip title="Download">
                                                                                                            <img
                                                                                                                src={downloadImage}
                                                                                                                alt="downloadImage"
                                                                                                                className="downlaodImg downloadImgTop"
                                                                                                            />
                                                                                                        </Tooltip>
                                                                                                    </span>
                                                                                                </span>
                                                                                            ) : null}
                                                                                        </span>
                                                                                    ) : null}
                                                                                </FormControl>
                                                                            ) : (
                                                                                // </Grid>

                                                                                ''
                                                                            )}
                                                                        </span>
                                                                    ) : null}
                                                                    {user.isAttachmentRequired === true ? (
                                                                        <Grid item xs={12} sm={6}>
                                                                            <FormControl fullWidth>
                                                                                <div className={classes.btnFieldPositionRight}>
                                                                                    <label htmlFor="raised-button-file">
                                                                                        <Button
                                                                                            onClick={handleClick}
                                                                                            color="primary"
                                                                                            variant="outlined"
                                                                                            className="txt-capitalize w100 mt15"
                                                                                        >
                                                                                            Upload Document
                                                                                        </Button>
                                                                                    </label>
                                                                                    {filename ? (
                                                                                        <p className="fileName">
                                                                                            {filename.substring(0, 15)}
                                                                                            {filename.length > 15 ? '...' : ''}
                                                                                        </p>
                                                                                    ) : null}
                                                                                    <Dialog
                                                                                        onClose={handleClose}
                                                                                        PaperProps={{
                                                                                            className: 'QandADailogBox',
                                                                                            style: { padding: '20px' },
                                                                                        }}
                                                                                        aria-labelledby="form-dialog-title"
                                                                                        open={handleOpen}
                                                                                        clear={clearData}
                                                                                        // disableBackdropClick
                                                                                    >
                                                                                        <DialogTitle id="form-dialog-title">
                                                                                            Upload File
                                                                                            {/* <IconButton
                                                                                    aria-label="close"
                                                                                    className={classes.closeButton}
                                                                                    onClick={handleClose}
                                                                                >
                                                                                    <CloseIcon />
                                                                                </IconButton> */}
                                                                                        </DialogTitle>
                                                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                                                            <Button
                                                                                                className="btnOrange"
                                                                                                variant="outlined"
                                                                                                component="label"
                                                                                                color="default"
                                                                                            >
                                                                                                <i className="btnIcon">
                                                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                                                </i>{' '}
                                                                                                Add File
                                                                                                <input
                                                                                                    onChange={(e) =>
                                                                                                        isFileUpload(e, e.target.files)
                                                                                                    }
                                                                                                    type="file"
                                                                                                    style={{ display: 'none' }}
                                                                                                    accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                                                />
                                                                                            </Button>
                                                                                            <p className="fileName">
                                                                                                {filename.substring(0, 15)}
                                                                                                {filename.length > 15 ? '...' : ''}
                                                                                            </p>
                                                                                        </DialogContent>
                                                                                        <p className="fileName">{uploadSuccessfully}</p>

                                                                                        <DialogActions className="paddingBtm txtCenter">
                                                                                            <Button
                                                                                                className="btnBluepop"
                                                                                                onClick={fileUpload}
                                                                                                variant="contained"
                                                                                                disabled={isDisable}
                                                                                                component="label"
                                                                                                color="default"
                                                                                            >
                                                                                                Upload
                                                                                            </Button>
                                                                                            <Button
                                                                                                className="btnBluepop"
                                                                                                onClick={handleClose}
                                                                                                variant="contained"
                                                                                                component="label"
                                                                                                color="default"
                                                                                            >
                                                                                                Cancel
                                                                                            </Button>
                                                                                        </DialogActions>
                                                                                    </Dialog>
                                                                                </div>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </Grid>
                                                            ) : null}
                                                        </span>
                                                    );
                                                })}
                                        </div>
                                        {itecOpen && (
                                            <CrcDialog
                                                itecOpen={itecOpen}
                                                crcCategory={category}
                                                crcRemarks={remarks}
                                                updateCRCRelevance={updateCRCRelevance}
                                                handleItecClose={handleItecClose}
                                            />
                                        )}
                                    </form>
                                </CardContent>
                                <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                            </Card>
                        </>
                    );
                }}
            </Formik>
        </>
    );
}
